import { render, staticRenderFns } from "./ActMembacaEbook.vue?vue&type=template&id=ed8fef52"
import script from "./ActMembacaEbook.vue?vue&type=script&lang=js"
export * from "./ActMembacaEbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports